module.exports = __webpack_public_path__ + "assets/images/checkbox-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/checkbox-on.png
// module id = 1495
// module chunks = 1